import { StatusFilter } from 'assets/js/pages/engage/types';
import { EngageMessageStatus, EngageTag } from 'types/domain';

const getStatusFromFilter = (status: StatusFilter): EngageMessageStatus[] => {
    switch (status) {
        case 'preparing':
        case 'queued':
        case 'sending':
            return ['preparing', 'queued', 'sending'];
        case 'sent':
            return ['sent', 'failed'];
        case 'draft':
        case 'failed':
        default:
            return [status];
    }
};

interface TransformedTag {
    title: string;
    value?: string;
    menu?: TransformedTag[];
}

const transformEngageTags = (engageTags: EngageTag[]): TransformedTag[] => {
    return engageTags.map(engageTag => {
        if (engageTag.options) {
            return {
                title: engageTag.title,
                menu: transformEngageTags(engageTag.options),
            };
        }

        return {
            title: engageTag.title,
            value: engageTag.value,
        };
    });
};

export { getStatusFromFilter, transformEngageTags };
